import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/Affinity_brochure.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/Affinity_product.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/Affinity_RGB_OL.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/affinity-novachor-products-group.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/Apligraf_1_2019_Top_shadow_RGB.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/Apligraf_RGB_OL.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/changin-lives-image.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/CYGNUS_Dual_4c_OL.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/Cygnus_Dual_brochure.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/CYGNUS_MATRIX_4c_OL.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/CYGNUS-Matrix_Product.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/Derm_brochure.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/dfu_brochure.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/Linda.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/logo-organogenesis.svg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/nav_bg_image.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/Novachor_product.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/Novachor_RGB_OL.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/PPAM_RGB_OL.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/PPXT_RGB_OL.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/product-overview-cygnus-dual.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/PuraPly_AM_PuraPly_AM_&_Brochure.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/puraply-products-info-group.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/PuraPlyAM_product.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/PuraPlyXT_product.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/Shopper_Man_Circle.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/via_cygnus_group.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/VIA_Matrix_RGB.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/VIA-Matrix_Product.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/vlu_brochure.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/svg/arrow-right.svg");
;
import(/* webpackMode: "eager", webpackExports: ["FormButton"] */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/_pages/_libs/components/form-button/form-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HighlightCard"] */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/_pages/resources-support/libs/sections/product-description/libs/components/highlight-card/highlight-card.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/_pages/resources-support/libs/sections/product-description/product-description.scss");
;
import(/* webpackMode: "eager", webpackExports: ["AsideNavigator"] */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/libs/components/aside-navigator/aside-navigator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/libs/components/button/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterCopyright"] */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/libs/components/footer/libs/components/footer-copyright/footer-copyright.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReferToApligraphBlock"] */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/libs/components/footer/libs/components/refer-to-apligraph-block/refer-to-apligraph-block.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollToTopButton"] */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/libs/components/footer/libs/components/scroll-to-top-button/scroll-to-top-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/libs/components/header/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LazyRecaptcha"] */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/libs/components/lazy-recaptcha/lazt-recaptcha.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReactQueryProvider"] */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/libs/components/react-query-provider/react-query-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tooltip"] */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/libs/components/tooltip/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useMediaQuery"] */ "/opt/atlassian/pipelines/agent/build/libs/shared/shared-utils/src/lib/use-media-query.ts");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/next-image-export-optimizer/dist/ExportedImage.js");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/next/dist/client/link.js");
